import invariant from 'invariant'
import { getIsCaptchaEnabled } from '../Configs'

function localStorageManager (key) {
  return {
    set: value => window.localStorage.setItem(key, JSON.stringify(value)),
    get: () => JSON.parse(window.localStorage.getItem(key)),
    clear: () => window.localStorage.removeItem(key)
  }
}

export class HcaptchaRunner {
  config = null
  fn = null
  scriptReady = false
  version = null
  ishCaptchaRunning = false
  hCaptchaTokenStorageManager = localStorageManager('ninjaCaptchaToken')
  runningRequests = {}

  constructor (config) {
    this.config = config
    this._init()
  }

  run = async (fn, action) => {
    let result = {}
    if (!getIsCaptchaEnabled()) {
      return fn('')
    }
    if (this.hasRunningRequests()) {
      await this._condition(() => !this.hasRunningRequests(), 50)
    }
    const requestIdentifier = Math.random() * Date.now()
    this.runningRequests[requestIdentifier] = true

    if (!this.hasValidToken()) {
      if (!this.ishCaptchaRunning) {
        this.ishCaptchaRunning = true
        await this.passiveExecute()
      }
      await this._condition(this.hasValidToken, 50)
    }
    result = await this._runProtected(fn)
    this.resetToken()
    delete this.runningRequests[requestIdentifier]
    return result
  }

  _init = () => {
    let script = document.createElement('script')
    script.setAttribute('src', this.config.url)
    document.head.appendChild(script)

    script.onload = () => {
      this.scriptReady = true
    }
  }

  setSuccessToken = response => {
    this.hCaptchaTokenStorageManager.set(this.version + '-' + response)
    this.ishCaptchaRunning = false
  }

  renderPassiveMode = () => {
    const { passiveSiteKey } = this.config
    let el = document.querySelector('#hcaptcha-passive-challenge')
    if (!el) {
      el = document.createElement('div')
      el.setAttribute('id', 'hcaptcha-passive-challenge')
      document.body.appendChild(el)
      window.passiveWidgetID = window.hcaptcha.render(el, {
        size: 'invisible',
        sitekey: passiveSiteKey,
        callback: this.setSuccessToken
      })
    }
    window.hcaptcha.execute(window.passiveWidgetID)
  }

  passiveExecute = async () => {
    this.version = 'passive'
    if (!this.scriptReady) {
      await this._condition(() => this.scriptReady)
    }
    this.renderPassiveMode()
  }

  _runProtected = async fn => {
    const token = this.hCaptchaTokenStorageManager.get()
    invariant(token, 'Recaptcha token is null')
    return fn(token)
  }

  _condition = async (check, timeout = 200) => {
    if (!check()) {
      await new Promise(resolve => setTimeout(resolve, timeout))
      return this._condition(check, timeout)
    }
  }

  resetToken = () => {
    this.hCaptchaTokenStorageManager.clear()
  }

  hasValidToken = () => {
    const token = this.hCaptchaTokenStorageManager.get()
    return !!token
  }

  hasRunningRequests = () => {
    return Object.keys(this.runningRequests)?.length > 0
  }
}
